/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * BaseLayout.tsx
 */

import React from 'react';
import {Route, Router, Switch} from "react-router-dom";

import App from './App';
import HomePage from './component/page/HomePage';
import UsersPage from "./component/page/UsersPage";
import HiloReactComponent from "./tools/view/layout/HiloReactComponent";
import LoginPage from "./component/page/LoginPage";
import User from "./models/User";
import ClientsPage from "./component/page/ClientsPage";
import SettingsPage from "./component/page/SettingsPage";
import ClientPage from "./component/page/ClientPage";
import UserPage from "./component/page/UserPage";
import NotFound from "./tools/view/element/NotFound";

interface Props {
    user?: User
}

export default class Container extends HiloReactComponent<Props, {}> {
    public render() {
        if (this.props.user) {
            return <Router history={App.history}>
                <Switch>
                    <Route path={"/"} exact component={HomePage}/>
                    <Route path={"/clients"} exact component={ClientsPage}/>
                    <Route path={"/client/:id"} exact component={ClientPage}/>
                    <Route path={"/settings"} exact component={SettingsPage}/>
                    <Route path={"/users"} exact component={UsersPage}/>
                    <Route path={"/user/:id"} exact component={UserPage}/>
                    <Route path={"*"} component={NotFound}/>
                </Switch>
            </Router>;
        } else {
            return <Router history={App.history}>
                <Switch>
                    <Route path={"/"} exact component={LoginPage}/>
                    <Route path={"*"} component={NotFound}/>
                </Switch>
            </Router>;
        }
    }
}
